<template>
  <div>
    <v-toolbar
      color="black"
      class="white--text my-2"
      style="border-radius: 15px;"
    >
      <v-btn flat icon class="white--text" @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card-text
        class="text-md-center text-xs-center"
        :style="{
          fontSize:
            $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '20px' : '28px',
        }"
      >
        Transaction History ({{ this.$route.params.firstname }}
        {{ this.$route.params.lastname }})
      </v-card-text>
    </v-toolbar>
    <v-card>
      <v-toolbar dense flat>
        <v-layout row wrap>
          <v-flex xs12 sm7>
            <v-text-field
              v-model.number="search"
              prepend-icon="search"
              label="Search transaction id "
              single-line
              hide-details
              style="padding: 0"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :loading="loadingMessage"
        :items="filtertransaction"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">
            {{ props.item.transaction_provider_wesmart_code }}
          </td>

          <td class="text-xs-center">
            {{
              props.item.transaction_provider_wesmart_type == "Top Up"
                ? "เติมเครดิต"
                : props.item.transaction_provider_wesmart_type == "Order"
                ? "สร้างออเดอร์"
                : props.item.transaction_provider_wesmart_type == "invoice"
                ? "ชำระ invoice"
                : null
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.transaction_provider_wesmart_credit < 0
                ? props.item.transaction_provider_wesmart_credit
                : "+" + props.item.transaction_provider_wesmart_credit
            }}
          </td>
          <td class="text-xs-center">
            {{ moment(props.item.create_at).format("YYYY/MM/DD HH:mm:ss") }}
          </td>
        </template>
        <template slot="no-data"></template>
      </v-data-table>
      <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
        <v-icon color="red">close</v-icon>
        {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
        <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  props: ["searchLog"],
  data: () => ({
    search: null,
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    search: "",
    headers: [
      {
        text: "Transacton id",
        value: "transaction_provider_wesmart_code",
        sortable: false,
        align: "center",
      },
      {
        text: "Type",
        value: "transaction_provider_wesmart_type",
        sortable: false,
        align: "center",
      },
      {
        text: "Amount(Client)",
        sortable: false,
        value: "transaction_provider_wesmart_credit",
        align: "center",
      },
      {
        text: "Date/Time",
        sortable: false,
        value: "create_at",
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
    data_loading: false,
  }),
  computed: {
    ...mapState({
      businessClient: (state) => state.Business.businessClient,
      transaction: (state) => state.Business.transaction,
    }),
    filtertransaction() {
      return this.transaction.filter((val) =>
        val.transaction_provider_wesmart_code.includes(this.search)
      );
    },
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
    }),
    goBack() {
      this.$router.go(-1);
    },
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch(
        "Business/fetchTransactionByUser",
        this.$route.params.business_id
      );
      this.loadingMessage = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>
